import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ILabRegistration } from '../../models/lab-user-menu/lab-registration';
import { ILabApplication } from '../../models/application-menu/lab-application';
import { environment } from '@env/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root',
})

export class LabUserMenuService {
  private api: string = environment.privateApi + 'MainMenu/';

  // Mat-table settings
  labFilter: string = '';
  expandedElement: ILabRegistration | null;

  constructor(private http: HttpClient){}

  activeUser(): Observable<Boolean> {
    return this.http.get<Boolean>(this.api + 'activeUser', httpOptions);
  }

  getUserLabs(): Observable<ILabRegistration[]> {
    return this.http.get<ILabRegistration[]>(this.api + "UserLabs", httpOptions);
  }

  getLabApplications(orelapId: string): Observable<ILabApplication[]> {
    return this.http.get<ILabApplication[]>(this.api + 'LabApplications/' + orelapId);
  }
}
